import React from 'react';
import { executeQuery } from "../../requests/executeQuery";
import {
    AGENT_COMMISSION_BREAKDOWN_PROCURED,
    AGENT_COMMISSION_BREAKDOWN_PAID,
    AGENT_COMMISSION_PAID_ALL,
    AGENT_COMMISSION_PROCURED_ALL,
    GET_YEARLY_TOTAL_COMMISSION_ALL
} from '../../consts/queries';
import PipelineTable from "../PipelineTable";
import Input from '../Input-new/Input';
import filter from "../../filter";
import { getData } from "../../requests/CRUD";
import { TEAM } from "../../consts/tables";
import { getCurrentAccess } from "../../access";
import { isOwnCommissionOnly } from "../../access-levels";
import { renderPrintFooter ,removeDuplicateObjects, filterAgentsByDate,
    filterAgentsWithoutCommisionInTerminationYear} from "../../utils";

const cloneDeep = require('lodash.clonedeep');
const find = require('lodash.find');

const totalKey = 'Total';

function getColumns(year) {
    const prevYear = year - 1;
    return [{
        name: 'Agent',
        key: 'name',
        class: 'PipelineTable_align_left',
        hasLink: 'agent-pipeline',
    }, {
        name: 'Gross - Procured',
        key: 'grossProcured',
        format: '$',
        withCents: true,
        hasLink: 'agent-commission-procured',
        year: year
    }, {
        name: 'Gross - Paid',
        key: 'grossPaid',
        format: '$',
        withCents: true,
        hasLink: 'agent-commission-paid',
        year: year
    }, {
        name: 'Gross - Delta',
        key: 'delta',
        format: '$',
        withCents: true,
    }, {
        name: 'Net - Procured',
        key: 'netProcured',
        format: '$',
        withCents: true,
        //hasLink: 'agent-commission-procured',
        year: year
    }, {
        name: 'Net - Paid',
        key: 'netPaid',
        format: '$',
        withCents: true,
        //hasLink: 'agent-commission-paid',
        year: year
    }, {
        name: 'Net - Delta',
        key: 'netDelta',
        format: '$',
        withCents: true,
    }, {
        name: `Net - Delta ${prevYear}`,
        key: 'netPrevYear',
        format: '$',
        withCents: true,
    }, {
        name: 'Total',
        key: 'total',
        format: '$',
        withCents: true,
    }];
}

function compareDates(a,b){
    const dateA = new Date(a.CLOSE_OF_ESCROW);
    const dateB = new Date(b.CLOSE_OF_ESCROW);
    return dateA - dateB;
}

const initializeRow = () => {
    return {
        id: 0,
        grossProcured: 0,
        grossPaid: 0,
        delta: 0,
        netProcured: 0,
        netPaid: 0,
        netDelta: 0,
        netPrevYear: 0,
        total: 0,
        
        prevYearTotal:0,
    }
};

// "Prior Agent" (TEAM 25) is the bookkeeping placeholder that legacy Summit
// closings are remapped to (RemapLegacySummitAgentsCommand) — not a person, so
// it never gets a breakdown row, even when remapped deals carry figures.
const withoutPriorAgent = (agents) =>
    agents.filter(agent => !(agent.AGENT_FIRST_NAME === 'Prior' && agent.AGENT_LAST_NAME === 'Agent'));

/** The signed-in agent's own rows, matched by TEAM id (names change and repeat). */
const findAgentRow = (rows, ownId) => {
    if (!rows || !rows.length || ownId == null || ownId === '') {
        return [];
    }
    return rows.filter((row) => row.AGENT_ID != null && String(row.AGENT_ID) === String(ownId));
};

export default class AgentCommissionBreakdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            query: {
                YEAR: new Date().getFullYear()
            },
            rows: {},
            subtitle: '',
            isPrint: false,
            loading: false,
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.renderPrintDocument = this.renderPrintDocument.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.splitRowsToPages = this.splitRowsToPages.bind(this);
    }

    static buildData(stateRows, data, pastYearData, year) {
        const rows = { ...stateRows };

        if (pastYearData)
            pastYearData.map(row => {
                let fullname = `${row.AGENT_LAST_NAME}${row.AGENT_FIRST_NAME}`;
                if (!rows[fullname])
                    rows[fullname] = initializeRow();
                if (!rows[fullname].id)
                    rows[fullname].id = row.AGENT_ID;
                if (!rows[fullname].name)
                    rows[fullname].name = row.AGENT_FIRST_NAME.charAt(0) + ". " + row.AGENT_LAST_NAME;//`${row.AGENT_FIRST_NAME} ${row.AGENT_LAST_NAME}`;
                if (!rows[fullname].lastName)
                    rows[fullname].lastName = row.AGENT_LAST_NAME;

                const grossPaid = row.PAID_GROSS_FEE ? parseFloat(row.PAID_GROSS_FEE) : 0;

                const listingProcuredGrossFee = row.LISTING_PROCURED_GROSS_FEE ? parseFloat(row.LISTING_PROCURED_GROSS_FEE) : 0;
                const buyingProcuredGrossFee = row.BUYING_PROCURED_GROSS_FEE ? parseFloat(row.BUYING_PROCURED_GROSS_FEE) : 0;
                const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
                const delta = grossPaid - totalProcuredGrossFee;
  
                rows[fullname].netProcured = row.netProcured;
                rows[fullname].netPaid = row.netPaid;
                rows[fullname].netDelta = Number(row.netPaid || 0) - Number(row.netProcured || 0);

                // "Net - Delta {prevYear}" = the prior year's own Net Delta
                // (prev-year Net-Paid - Net-Procured), so Total can subtract it.
                // Net-Delta 2025 is hardcoded to $0 per business request.
                rows[fullname].netPrevYear = (Number(year) - 1 === 2025) ? 0 : rows[fullname].netDelta;
            });

        data.map(row => {
            let fullname = `${row.AGENT_LAST_NAME}${row.AGENT_FIRST_NAME}`;
            if (!rows[fullname])
                rows[fullname] = initializeRow();
            if (!rows[fullname].id)
                rows[fullname].id = row.AGENT_ID;
            if (!rows[fullname].name)
                rows[fullname].name = row.AGENT_FIRST_NAME.charAt(0) + ". " + row.AGENT_LAST_NAME;
            if (!rows[fullname].lastName)
                rows[fullname].lastName = row.AGENT_LAST_NAME;

            rows[fullname].grossPaid = row.PAID_GROSS_FEE ? parseFloat(row.PAID_GROSS_FEE) : 0;

            const listingProcuredGrossFee = row.LISTING_PROCURED_GROSS_FEE ? parseFloat(row.LISTING_PROCURED_GROSS_FEE) : 0;
            const buyingProcuredGrossFee = row.BUYING_PROCURED_GROSS_FEE ? parseFloat(row.BUYING_PROCURED_GROSS_FEE) : 0;
            const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
            rows[fullname].grossProcured = totalProcuredGrossFee;

            rows[fullname].delta = rows[fullname].grossPaid - totalProcuredGrossFee;

            if (!rows[fullname].netPrevYear)
                rows[fullname].netPrevYear = 0;

            rows[fullname].netProcured = row.netProcured;
            rows[fullname].netPaid = row.netPaid;
            rows[fullname].netDelta = rows[fullname].netPaid - rows[fullname].netProcured;
            rows[fullname].total = rows[fullname].netDelta - rows[fullname].netPrevYear;
        });

        return rows;
    }

    static buildTotalData(stateRows) {
        const rows = { ...stateRows, [totalKey]: initializeRow() };

        Object.keys(rows[totalKey]).map(columnKey => {
            if (columnKey !== "id") {
                rows[totalKey][columnKey] = Object.keys(rows)
                    .reduce((previous, key) => previous + (typeof rows[key][columnKey] === 'string' ? parseFloat(rows[key][columnKey]) : rows[key][columnKey]), 0);
            }
        });

        return rows;
    }

    /**
     * Every Summit Agent (TEAM.IS_AGENT = 'a', not deleted) should appear as a
     * row even with no commission in the period. Append a zero-fee row for each
     * roster agent not already present, carrying the TEAM start/termination
     * dates so the existing active-in-year filters still apply.
     */
    static unionRoster(data, roster) {
        const present = new Set(data.map((agent) => String(agent.AGENT_ID)));

        const additions = (roster || [])
            .filter((member) => !present.has(String(member.ARCIMEDES_ROW_ID)))
            .map((member) => ({
                AGENT_ID: member.ARCIMEDES_ROW_ID,
                AGENT_FIRST_NAME: member.FIRST_NAME || '',
                AGENT_LAST_NAME: member.LAST_NAME || '',
                AGENT_STARTING_DATE: member.STARTING_DATE || null,
                AGENT_TERMINATION_DATE: member.TERMINATION_DATE || null,
                LISTING_PROCURED_GROSS_FEE: 0,
                BUYING_PROCURED_GROSS_FEE: 0,
                PAID_GROSS_FEE: 0,
            }));

        return data.concat(additions);
    }

    static mergeData(procuredData, paidData) {
        const data = cloneDeep(procuredData);

        data.forEach(agent => {
            const matchedAgent = find(paidData, { AGENT_ID: agent.AGENT_ID })
            if (matchedAgent)
                agent.PAID_GROSS_FEE = matchedAgent.PAID_GROSS_FEE;
        });

        // An agent can be paid in a year they procured nothing (e.g. paid after
        // termination) — they still need a report row, else their dollars vanish
        // from the totals.
        paidData.forEach(paidAgent => {
            if (!find(data, { AGENT_ID: paidAgent.AGENT_ID }))
                data.push({
                    ...cloneDeep(paidAgent),
                    LISTING_PROCURED_GROSS_FEE: 0,
                    BUYING_PROCURED_GROSS_FEE: 0,
                });
        });

        return data;
    }

    beforePrint() {
        this.setState({ isPrint: true });
    }

    afterPrint() {
        this.setState({ isPrint: false });
    }
    static applyTrancheLogic(grossPaid, prevProcuredCumulative, grossCumulative, tranche, previousPercentage) {
        let newPercentage = previousPercentage + 0.05;
        if(prevProcuredCumulative<tranche){
            if(grossPaid >= (tranche - prevProcuredCumulative) ) {
                netProcured += (tranche - prevProcuredCumulative) * previousPercentage+(grossCumulative - tranche) * newPercentage;
                netPaid += (tranche - prevProcuredCumulative) * previousPercentage + (teamMemberGrossFee - (tranche - prevProcuredCumulative)) * newPercentage;
            } else {
                netProcured += (tranche - prevProcuredCumulative) * previousPercentage+(grossCumulative - tranche) * newPercentage;
                netPaid += (grossPaid-(grossCumulative-tranche)) * previousPercentage + (grossCumulative - tranche) * newPercentage;
            }
        }else{
            netProcured += totalProcuredGrossFee * newPercentage;  
            netPaid += teamMemberGrossFee * newPercentage;
        } 
    }

    /**
     * `bulk` holds the year's AGENT_COMMISSION_PROCURED_ALL /
     * AGENT_COMMISSION_PAID_ALL / GET_YEARLY_TOTAL_COMMISSION_ALL responses,
     * grouped in fetch() — one request per query instead of three per agent.
     * A null bulk (a query failed) skips the net figures for every agent,
     * matching the old behavior when a per-agent query failed.
     */
    static calculateNet(data, query, year, prevYear, bulk) {
        data.forEach((agent) => {
            if (bulk) {
                const res = [
                    { success: true, data: bulk.procuredByAgent.get(String(agent.AGENT_ID)) || [] },
                    { success: true, data: bulk.paidRows },
                    { success: true, data: bulk.totalsById.get(String(agent.AGENT_ID)) || [] },
                ];

                let grossCumulative = 0;
                let netProcured = 0;
                let prevProcuredCumulative = 0;
                let netPaid = 0;
                let paidData = removeDuplicateObjects(res[1].data.filter(property => String(property.MEMBER_ID) === String(agent.AGENT_ID)));
                let map = new Map();

                res[0].data.forEach(item => {
                    map.set(item.ARCIMEDES_ROW_ID, item);
                });

                paidData.forEach(item => {
                    if (map.has(item.ARCIMEDES_ROW_ID)) {
                        let { TEAM_MEMBER_GROSS_FEE, TEAM_MEMBER_NET_FEE } = item;
                        map.set(item.ARCIMEDES_ROW_ID, { ...map.get(item.ARCIMEDES_ROW_ID), TEAM_MEMBER_GROSS_FEE, TEAM_MEMBER_NET_FEE });
                    } else {
                        map.set(item.ARCIMEDES_ROW_ID, item);
                    }
                });

                const mergedArray = Array.from(map.values());
                mergedArray.sort(compareDates);
                mergedArray.forEach((propertyObj, index) => {
                    // An Extra Payment stays out of every procured figure, but its
                    // Net Amount (the payment-team net fee) is paid out as-is —
                    // outside the tranche schedule.
                    if (propertyObj.TRANSACTION_TYPE === 'Extra Payment') {
                        netPaid += propertyObj.TEAM_MEMBER_NET_FEE ? parseFloat(propertyObj.TEAM_MEMBER_NET_FEE) : 0;
                        return;
                    }

                    const listingProcuredGrossFee = propertyObj.LISTING_GROSS_COMMISSION ? parseFloat(propertyObj.LISTING_GROSS_COMMISSION) : 0;
                    const buyingProcuredGrossFee = propertyObj.BUYING_GROSS_COMMISSION ? parseFloat(propertyObj.BUYING_GROSS_COMMISSION) : 0;

                    const totalProcuredGrossFee = listingProcuredGrossFee + buyingProcuredGrossFee;
                    let teamMemberGrossFee = propertyObj.TEAM_MEMBER_GROSS_FEE ? parseFloat(propertyObj.TEAM_MEMBER_GROSS_FEE) : 0;
                    grossCumulative += totalProcuredGrossFee;

                    if (grossCumulative <= 200000) {
                        netProcured += totalProcuredGrossFee * 0.5;
                        netPaid += teamMemberGrossFee * 0.5;
                    } else if (grossCumulative > 200000 && grossCumulative <= 400000) {
                        if (prevProcuredCumulative < 200000) {
                            if (teamMemberGrossFee >= (200000 - prevProcuredCumulative)) {
                                netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                netPaid += (200000 - prevProcuredCumulative) * 0.5 + (teamMemberGrossFee - (200000 - prevProcuredCumulative)) * 0.55;
                            } else {
                                netProcured += (200000 - prevProcuredCumulative) * 0.5 + (grossCumulative - 200000) * 0.55;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 200000)) * 0.5 + (grossCumulative - 200000) * 0.55;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.55;
                            netPaid += teamMemberGrossFee * 0.55;
                        }
                    } else if (grossCumulative > 400000 && grossCumulative <= 600000) {
                        if (prevProcuredCumulative < 400000) {
                            if (teamMemberGrossFee >= (400000 - prevProcuredCumulative)) {
                                netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                netPaid += (400000 - prevProcuredCumulative) * 0.55 + (teamMemberGrossFee - (400000 - prevProcuredCumulative)) * 0.6;
                            } else {
                                netProcured += (400000 - prevProcuredCumulative) * 0.55 + (grossCumulative - 400000) * 0.6;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 400000)) * 0.55 + (grossCumulative - 400000) * 0.6;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.6;
                            netPaid += teamMemberGrossFee * 0.6;
                        }
                    } else if (grossCumulative > 600000 && grossCumulative <= 800000) {
                        if (prevProcuredCumulative < 600000) {
                            if (teamMemberGrossFee >= (600000 - prevProcuredCumulative)) {
                                netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                netPaid += (600000 - prevProcuredCumulative) * 0.6 + (teamMemberGrossFee - (600000 - prevProcuredCumulative)) * 0.65;
                            } else {
                                netProcured += (600000 - prevProcuredCumulative) * 0.6 + (grossCumulative - 600000) * 0.65;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 600000)) * 0.6 + (grossCumulative - 600000) * 0.65;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.65;
                            netPaid += teamMemberGrossFee * 0.65;
                        }
                    } else if (grossCumulative > 800000) {
                        if (prevProcuredCumulative < 800000) {
                            if (teamMemberGrossFee >= (800000 - prevProcuredCumulative)) {
                                netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                netPaid += (800000 - prevProcuredCumulative) * 0.65 + (teamMemberGrossFee - (800000 - prevProcuredCumulative)) * 0.7;
                            } else {
                                netProcured += (800000 - prevProcuredCumulative) * 0.65 + (grossCumulative - 800000) * 0.7;
                                netPaid += (teamMemberGrossFee - (grossCumulative - 800000)) * 0.65 + (grossCumulative - 800000) * 0.7;
                            }
                        } else {
                            netProcured += totalProcuredGrossFee * 0.7;
                            netPaid += teamMemberGrossFee * 0.7;
                        }
                    }
                    prevProcuredCumulative = grossCumulative;
                });
    
                let targetAgent = data.find(obj => String(obj.AGENT_ID) === String(agent.AGENT_ID));
                if (targetAgent) {
                    targetAgent['netProcured'] = netProcured;
                    targetAgent['netPaid'] = netPaid;
                    if (prevYear != 0) {
                        targetAgent['prevYearTotal'] = res[2].data && res[2].data[0] ? res[2].data[0].TOTAL : 0;
                    }
                }
            }
        });

        let cleanedData = filterAgentsWithoutCommisionInTerminationYear(data, year);

        return cleanedData;
    }


    updateToNetValues(data,pastYearData,query,year,bulkByYear){
        const updatedData = AgentCommissionBreakdown.calculateNet(data,query,year,0,bulkByYear[year]);
        const updatedPastYearData = AgentCommissionBreakdown.calculateNet(pastYearData,query,0,year-1,bulkByYear[year-1]);

            let rows = {};
            rows = AgentCommissionBreakdown.buildData(rows, updatedData, updatedPastYearData, year);
            if(Object.keys(rows).length!==0){
                rows = AgentCommissionBreakdown.buildTotalData(rows);
            }
            this.setState({subtitle: year, rows});
            this.setState({loading: false});
        
    }

    fetch() {
        this.setState({loading: true});
        const query = { ...this.state.query };
        const year = query.YEAR ? query.YEAR : new Date().getFullYear();
        let q = {
            YEAR: year
        }
        const options = filter(q, 'agent-commission-break-down');

        const groupRows = (rows, key) => {
            const map = new Map();
            rows.forEach(row => {
                const k = String(row[key]);
                if (!map.has(k)) map.set(k, []);
                map.get(k).push(row);
            });
            return map;
        };
        // Net figures need only the procured/paid bulk rows. The yearly-totals
        // query (GET_YEARLY_TOTAL_COMMISSION_ALL) reads NET_COMMISSIONS, which is
        // absent in some environments (e.g. local); it must NOT gate the net
        // calc — prior-year Net Delta is derived from the fetched prior-year data
        // instead. So bulk is null only when procured or paid failed.
        const makeBulk = (procured, paid, totals) =>
            procured && procured.success && Array.isArray(procured.data) &&
            paid && paid.success && Array.isArray(paid.data)
                ? {
                    procuredByAgent: groupRows(procured.data, 'AGENT_ID'),
                    paidRows: paid.data,
                    totalsById: totals && totals.success && Array.isArray(totals.data)
                        ? groupRows(totals.data, 'ID')
                        : new Map(),
                }
                : null;

        Promise.all([
            executeQuery({ queryName: AGENT_COMMISSION_BREAKDOWN_PROCURED, params: { YEAR: year } }),
            executeQuery({ queryName: AGENT_COMMISSION_BREAKDOWN_PAID, options }),
            executeQuery({ queryName: AGENT_COMMISSION_BREAKDOWN_PROCURED, params: { YEAR: year - 1 } }),
            executeQuery({ queryName: AGENT_COMMISSION_BREAKDOWN_PAID, params: { YEAR: year - 1 } }),
            executeQuery({ queryName: AGENT_COMMISSION_PROCURED_ALL, params: { YEAR: year } }),
            executeQuery({ queryName: AGENT_COMMISSION_PAID_ALL, params: { YEAR: year } }),
            executeQuery({ queryName: GET_YEARLY_TOTAL_COMMISSION_ALL, params: { YEAR: year } }),
            executeQuery({ queryName: AGENT_COMMISSION_PROCURED_ALL, params: { YEAR: year - 1 } }),
            executeQuery({ queryName: AGENT_COMMISSION_PAID_ALL, params: { YEAR: year - 1 } }),
            executeQuery({ queryName: GET_YEARLY_TOTAL_COMMISSION_ALL, params: { YEAR: year - 1 } }),
            getData({
                tableCode: TEAM,
                options: {
                    column: ['ARCIMEDES_ROW_ID', 'FIRST_NAME', 'LAST_NAME', 'STARTING_DATE', 'TERMINATION_DATE', 'DELETED', 'IS_AGENT'],
                    filter: [
                        { text: 'n', code: 'DELETED', type: 'exact' },
                        { text: 'a', code: 'IS_AGENT', type: 'exact' },
                    ],
                    filterType: 'and',
                    order: [{ code: 'LAST_NAME', type: 'asc' }, { code: 'FIRST_NAME', type: 'asc' }],
                },
            })
        ]).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data)) {
                var data = AgentCommissionBreakdown.mergeData(res[0].data, res[1].data);
                var pastYearData = AgentCommissionBreakdown.mergeData(res[2].data, res[3].data);

                if (isOwnCommissionOnly(getCurrentAccess())) {
                    const ownId = this.props.userData && this.props.userData.id;
                    data = findAgentRow(data, ownId);
                    pastYearData = findAgentRow(pastYearData, ownId);
                } else {
                    // Show every Summit Agent, including those with no commission.
                    const roster = res[10] && res[10].success && Array.isArray(res[10].data) ? res[10].data : [];
                    data = AgentCommissionBreakdown.unionRoster(data, roster);
                }
                const fliteredData = filterAgentsByDate(withoutPriorAgent(data), year);
                const filteredPastYearData = filterAgentsByDate(withoutPriorAgent(pastYearData), year);
                const bulkByYear = {
                    [year]: makeBulk(res[4], res[5], res[6]),
                    [year - 1]: makeBulk(res[7], res[8], res[9]),
                };
                this.updateToNetValues(fliteredData,filteredPastYearData,query,year,bulkByYear);
            }
        });
    }

    onSubmit(e) {
        if (e.key === 'Enter') {
            this.fetch();
        }
    }
    
    componentDidMount() {
        this.fetch();
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    handleInputChange(e) {
        const key = e.currentTarget.name;
        let value = e.currentTarget.value;
        let query = { ...this.state.query };
        query[key] = value;
        this.setState({ query });
    }

    splitRowsToPages(rows, rowsPerPage) {
        const keys = Object.keys(rows);
        let allPages = [];
        let currentPage = {};

        keys.forEach((key, index) => {
            currentPage[key] = rows[key];
            if ((index + 1) % rowsPerPage === 0 || index === keys.length - 1) {
                allPages.push(currentPage);
                currentPage = {};
            }
        })
        return allPages;
    }

    renderPrintDocument(rows, columns, subtitle) {
        const allPages = this.splitRowsToPages(rows, 20);

        return (
            allPages.map((page, index) => (
                <div className='content' style={{  background: `url('${arc.path.media+'Transaction_Background.png'}')` }}>
                <div key={index} className='print-container' >
                    <div className='AgentCommissionBreakdown_header'>
                        <h3 className='AgentCommissionBreakdown_h3'>Agent Commission Breakdown</h3>
                        <h4 className='AgentCommissionBreakdown_h4'>{subtitle}</h4>
                    </div>
                    <PipelineTable className="table" rows={page} columns={columns} />
                   </div>
                   <div className='AgentCommissionBreakdown_footer'>
                    {renderPrintFooter(true)}
                    </div>
                    <div className='page-break'></div>
                
                </div>
            ))

        )
    }

    render() {
        const { rows, query, subtitle, isPrint,loading } = this.state;
        const columns = getColumns(subtitle);

        return (
            <div className='AgentCommissionBreakdown'>
                {(!isPrint && <div className='title-row'><div className='AgentCommissionBreakdown_header'>
                    <div className="year-input">
                        <Input
                            name='YEAR'
                            label='YEAR'
                            data={query}
                            value={query.YEAR}
                            onChange={this.handleInputChange}
                            onKeyUp={this.onSubmit}
                            viewMode={loading}
                        />
                    </div>
                    <h3 className='AgentCommissionBreakdown_h3'>Agent Commission Breakdown</h3>
                    <h4 className='AgentCommissionBreakdown_h4'>{subtitle}</h4>
                </div></div>)}
                {loading ? (
                    <div className='AgentCommissionBreakdown_loading'>
                        <div className='AgentCommissionBreakdown_skeleton'>
                            <div className='AgentCommissionBreakdown_skeleton-row head'>
                                {columns.map((column) => (
                                    <div key={column.key} className='AgentCommissionBreakdown_skeleton-cell' />
                                ))}
                            </div>
                            {Array.from({ length: 8 }).map((_, rowIndex) => (
                                <div key={rowIndex} className='AgentCommissionBreakdown_skeleton-row'>
                                    {columns.map((column, cellIndex) => (
                                        <div key={column.key}
                                             className='AgentCommissionBreakdown_skeleton-cell'
                                             style={{ animationDelay: `${(rowIndex * columns.length + cellIndex) * 0.04}s` }} />
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div className='AgentCommissionBreakdown_loading-caption'>
                            <div className='AgentCommissionBreakdown_loading-spinner' />
                            <span>Loading commission data...</span>
                        </div>
                    </div>
                ) :
                !isPrint && <PipelineTable rows={rows} columns={columns} hasTotalRow className='list' linkInNewTab={true} />}
                {isPrint && this.renderPrintDocument(rows, columns,subtitle)}
            </div>
        );
    }
}